import angular from 'angular'

import vdFocus from './vd-focus.directive'

angular.module('vend.ui').directive('vdFocus', vdFocus)
